import _ from "lodash";
import protocol_ISAScholarship from "../../../../makepdfs/scholarship/protocol_ISAScholarship";
import ExtractFromProtocolISAScholarship from "../../../../makepdfs/scholarship/ExtractFromProtocolISAScholarship";
import PersonNameConverter from "./PersonNameConverter";
import GetCourseStudent from "./GetCourseStudent";
import store from '../../../../stores/application/index.js.erb'
import moment from "moment";

const CreateProtocolScholarship = {

  statements: [],
  employees: [],
  department: "",
  meeting: store.state.scholarship_meeting.meeting,


  listenersArrayToString(listeners, studentChairmanAsset) {
    let currentListeners = [...listeners]
    currentListeners.push(studentChairmanAsset)

    currentListeners = _.sortBy(_.map(_.compact(currentListeners), listener => PersonNameConverter.shortName(listener)));
    return currentListeners.join(", ");

  },

  fullName(person) {
    try {
      let fullname = person.surname + " " + person.name[0] + "."
      if (person?.patronymic !== null && person?.patronymic !== "") fullname += person.patronymic[0] + "."
      return fullname
    } catch (e) {
      console.log(e);
      console.log(person)
    }
  },

  formatDate(dateString) {
    if (_.isNil(dateString)) return "«____».___________.20____";
    return moment(dateString)?.format('«DD».MM.YYYY');
  },

  signatureArray(listeners, studentChairmanAsset) {
    const arrayListeners = this.listenersArrayToString(listeners, studentChairmanAsset).split(",");
    let signaturesArray = [];
    _.forEach(arrayListeners, (i) => {
      signaturesArray.push({
        margin: [0, 0, 0, 20],
        columns: [
          {
            text: "Члены стипендиальной комиссии",
            style: "thirteenBold",
            width: 300,
          },

          {
            width: '*',
            canvas:
              [{ type: 'line', x1: 0, y1: 15, x2: 100, y2: 15, lineWidth: 1 }]
          },

          {
            text: i,
            style: "thirteenBold",
            width: "auto",
          }
        ],
      })
    });

    return signaturesArray;
  },

  arrayCandidatesToPDFProtocol() {
    const statements = _.cloneDeep(this.statements);

    return _.map(statements, (currentStatement)=> {
      let statement = [];
      statement.push(statements.indexOf(currentStatement) + 1);
      statement.push(currentStatement.person_full_name);
      statement.push(`${GetCourseStudent.call(currentStatement.group_name)}, ${currentStatement.group_name}`);
      statement.push(currentStatement.achievement_type_name);
      statement.push(currentStatement.sum_score_education);
      statement.push(currentStatement.sum_score_research);
      statement.push(currentStatement.sum_score_social_activity);
      statement.push(currentStatement.sum_score_cultural_creative);
      statement.push(currentStatement.sum_score_sports);
      statement.push(currentStatement.sum_score);
      return statement
    })
  },

  arrayCandidatesToPDFExtract() {
    const statements = _.cloneDeep(this.statements);

    return _.map(_.sortBy(statements, ['sum_score']).reverse(), (statement)=> {
      let candidate = [];
      candidate.push(statements.indexOf(statement) + 1);
      candidate.push(statement.person_full_name);
      candidate.push(`${GetCourseStudent.call(statement.group_name)}, ${statement.group_name}`);
      candidate.push(statement.achievement_type_name);
      candidate.push(statement.sum_score);
      return candidate
    })
  },

  cratePDF() {
    const chairman = this.meeting.chairman?.full_name;
    const secretary = this.meeting.secretary?.full_name;
    const listeners = _.map(this.meeting.listeners, listener => listener.full_name);
    const studentChairmanAsset = this.meeting.student_chairman_asset?.full_name;

    protocol_ISAScholarship.createPDF(
      this.formatDate(this.meeting.meeting_date),
      PersonNameConverter.shortName(chairman),
      PersonNameConverter.shortName(secretary),
      this.department,
      this.listenersArrayToString(listeners, studentChairmanAsset),
      this.signatureArray(listeners, studentChairmanAsset),
      this.arrayCandidatesToPDFProtocol()
    )
  },

  cratePDFExtract() {
    const chairman = this.meeting.chairman?.full_name;
    const secretary = this.meeting.secretary?.full_name;
    const listeners = _.map(this.meeting.listeners, listener => listener.full_name);
    const studentChairmanAsset = this.meeting.student_chairman_asset?.full_name;

    ExtractFromProtocolISAScholarship.createPDF(
      this.formatDate(this.meeting.meeting_date),
      PersonNameConverter.shortName(chairman),
      PersonNameConverter.shortName(secretary),
      this.department,
      this.listenersArrayToString(listeners, studentChairmanAsset),
      this.arrayCandidatesToPDFExtract()
    )
  },



}

export default CreateProtocolScholarship
